import { ProcedureDropdownActions } from './ProcedureDropdownActions';

export const procedureDropdownReducer = (state = {}, action) => {
    switch (action.type) {
        case ProcedureDropdownActions.CHANGE_PROCEDURE: {
            return {
                ...state,
                procedureId: action.procedureId,
                insuranceMayNotCover: action.insuranceMayNotCover,
            };
        }

        default:
            return state;
    }
};
